import "../../global.css";
import "./customerList.css";
import { setState } from "../../redux/dataGridRedux";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import CustomGrid from "../../components/grid/CustomGrid";
import * as React from "react";
import { DeleteOutline } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import { useState, useEffect, useRef } from "react";
import { userRequest } from "../../requestMethods";
import { useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import { formatTimeDDMMYYY } from "../../util/helper";
import Loading from "../../components/loading/loading";
import { useCompany } from "../../components/context/CompanyContext";
import Swal from "sweetalert2";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";
import MessageIcon from "@mui/icons-material/Message";
import { formatPricing } from "../../util/helper";
import { useDispatch, useSelector } from "react-redux";
import { setAllFilters } from "../../redux/customGridRedux";
import { storeScopeFilters } from "../../util/storeScope";
import cadastro from "../../icons/cadastro.svg";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import { titleSetRef } from "../../redux/titleRedux";
import { useSearchParams } from "react-router-dom";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
const style = {
  background: "white",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%,-50%)",
  padding: "60px",
  borderRadius: "15px",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
};

export default function CustomerList() {
  const [searchParams] = useSearchParams();
  const currentUser = useSelector((state) => state.user.currentUser);
  const allFilters = useSelector(
    (state) => state.customGrid["customerList"]?.allFilters || [],
  );
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [modalCustomer, setModalCustomer] = useState();
  const [name, setName] = useState();
  const { companyId, slug } = useCompany();
  const [pageSize, setPageSize] = useState(100);
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  // Filtros sintéticos (não são colunas do grid) — aplicados sempre no servidor
  const syntheticFiltersRef = useRef([]);

  const dateFilterStart = searchParams.get("start");
  const dateFilterEnd = searchParams.get("end");
  const enabledFilter = searchParams.get("enabled");
  const acessStart = searchParams.get("acessStart");
  const acessEnd = searchParams.get("acessEnd");
  const activeLast90 = searchParams.get("activeLast90");
  const customerIds = searchParams.get("customerIds");
  const reconquista = searchParams.get("reconquista");
  const inativos = searchParams.get("inativos");
  const acessType = searchParams.get("acessType"); // comprou | naoComprou | naoAcessou
  const storeIdParam = searchParams.get("storeId"); // loja(s) vindas do indicador
  const from = searchParams.get("from");

  useEffect(() => {
    dispatch(titleSetRef({ title: "Clientes" }));
  }, [dispatch]);

  useEffect(() => {
    // Reaplica sempre que os params da URL mudarem (troca de card/analítico) — sem
    // guard de "carrega uma vez", senão ao clicar em outro card o filtro antigo
    // fica fixado e não limpa.
    if (companyId > 0) {
      // Filtros que correspondem a colunas reais → vão para o grid (visíveis)
      const filters = [];
      if (dateFilterStart) {
        filters.push({
          field: "createdAt",
          operator: "greaterThanOrEqual",
          value: dateFilterStart,
        });
      }
      if (dateFilterEnd) {
        filters.push({
          field: "createdAt",
          operator: "lessThanOrEqual",
          value: dateFilterEnd,
        });
      }
      if (enabledFilter) {
        filters.push({
          field: "enabled",
          operator: "equals",
          value: enabledFilter,
        });
      }
      // acessStart/acessEnd viram filtro de coluna (acessAt) apenas quando NÃO há
      // bucket de acesso (Comprou/Não comprou/Não acessou), que usa o período no sintético.
      if (acessStart && !acessType) {
        filters.push({
          field: "acessAt",
          operator: "greaterThanOrEqual",
          value: acessStart,
        });
      }
      if (acessEnd && !acessType) {
        filters.push({
          field: "acessAt",
          operator: "lessThanOrEqual",
          value: acessEnd,
        });
      }

      // Filtro sintético (sem coluna no grid) → aplicado direto no servidor
      const synthetic = [];
      if (activeLast90) {
        synthetic.push({
          field: "activeLast90",
          operator: "equals",
          value: "true",
        });
      }
      if (reconquista) {
        synthetic.push({ field: "reconquista", operator: "equals", value: "true" });
      }
      if (inativos) {
        synthetic.push({ field: "inativos", operator: "equals", value: "true" });
      }
      if (acessType) {
        // Comprou / Não comprou / Não acessou no período (acessStart..acessEnd)
        const fieldMap = {
          acessou: "acessAcessou",
          comprou: "acessComprou",
          naoComprou: "acessNaoComprou",
          naoAcessou: "acessNaoAcessou",
        };
        const field = fieldMap[acessType];
        if (field) {
          synthetic.push({
            field,
            operator: "equals",
            value: `${acessStart || dateFilterStart || ""},${acessEnd || dateFilterEnd || ""}`,
          });
        }
      }
      if (customerIds) {
        synthetic.push({
          field: "customerIds",
          operator: "equals",
          value: customerIds,
        });
      }
      if (storeIdParam) {
        // Loja(s) vindas do indicador → filtra por loja do vendedor (managedBy)
        synthetic.push({ field: "storeId", operator: "equals", value: storeIdParam });
      }
      syntheticFiltersRef.current = synthetic;

      const cameFromHome = filters.length > 0 || synthetic.length > 0;
      if (cameFromHome) {
        // sincroniza o grid com os filtros de coluna (limpa estado antigo)
        dispatch(setAllFilters({ gridId: "customerList", filters }));
        getCustomers(1, pageSize, filters);
      } else {
        getCustomers();
      }
    }
  }, [
    companyId,
    dispatch,
    dateFilterStart,
    dateFilterEnd,
    enabledFilter,
    acessStart,
    acessEnd,
    activeLast90,
    customerIds,
    reconquista,
    inativos,
    acessType,
    storeIdParam,
  ]);

  useEffect(() => {
    if (modalCustomer) {
      setOpen(true);
    }
  }, [modalCustomer]);

  const getCustomers = async (
    newPage = page,
    newPageSize = pageSize,
    filtersToUse = null,
  ) => {
    try {
      setIsLoading(true);
      const baseFilters = filtersToUse !== null ? filtersToUse : allFilters;
      const extraFilters = [
        ...baseFilters,
        ...syntheticFiltersRef.current, // filtros sem coluna (ex: activeLast90)
        ...storeScopeFilters(currentUser),
      ];
      const qs = `&allFilters=${encodeURIComponent(JSON.stringify(extraFilters))}`;
      // _t evita resposta 304 (GET cacheado) que retornaria body vazio
      const url = `${companyId}/customers?page=${newPage}&limit=${newPageSize}&paginated=true${qs}&_t=${Date.now()}`;

      const res = await userRequest.get(url);
      if (res.data) {
        setData(res.data.rows);
        setTotalRows(res.data.totalRecords); // <── total vindo do backend
        setPage(newPage);
        setPageSize(newPageSize);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };
  const deleteCustomer = async (customer) => {
    const res = await userRequest.delete(`${companyId}/customers/${customer}`);
    if (res.data > 0) {
      getCustomers();
    } else {
      Swal.fire("Atenção!", "Erro ao excluir cliente!", "error");
    }
  };

  const deleteLogico = async (customer) => {
    try {
      const res = await userRequest.put(`${companyId}/customers/${customer}`, {
        deleted: new Date(),
        lastUserUpdate: currentUser.userId,
      });
      if (Object.keys(res.data).length > 0) {
        getCustomers();
      } else {
        Swal.fire("Atenção!", "Erro ao excluir cliente!", "error");
      }
    } catch (error) {}
  };
  const onButtonDeleteClick = (e, row) => {
    if (currentUser.isAdmin) {
      Swal.fire({
        title: "Tem certeza que deseja excluir?",
        text: "Você não poderá reverter isso!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#EE8253",
        confirmButtonText: "Sim, excluir!",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          //deleteCustomer(row);
          deleteLogico(row);
        }
      });
    } else {
      Swal.fire(
        "Atenção!",
        "Você não tem permissão para excluir cliente!",
        "warning",
      );
    }
  };
  const getCNPJ = async (cnpj) => {
    const res = await userRequest.get(`${companyId}/customers/cnpj/${cnpj}`);
    setModalCustomer(res.data);
  };
  const onButtonEditarClick = (e, row) => {
    nav(`${row}`);
  };
  const handleOpen = (e, cnpj, name) => {
    getCNPJ(cnpj);
    setName(name);
  };
  const nav = useNavigate();
  const addRow = () => {
    nav(`new`);
  };
  const handleChangePremium = async (e, row) => {
    await userRequest.put(`${companyId}/customers/${row}`, {
      presales: e.target.checked,
    });
  };
  const handlePageChangeServer = (newPage, newPageSize) => {
    getCustomers(newPage + 1, newPageSize);
  };
  const columns = [
    {
      field: "customerId",
      headerName: "ID",
      width: 80,
      align: "center",
      headerAlign: "center",
      clickable: true,
      type: "number",
    },
    {
      field: "editar",
      headerName: "",
      width: 60,
      align: "center",
      headerAlign: "center",
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const handleEditClick = (e) => {
          e.stopPropagation(); // impede o clique de acionar o onRowClick
          onButtonEditarClick(e, params.row.customerId);
        };

        return (
          <IconButton onClick={handleEditClick}>
            <EditIcon fontSize="small" />
          </IconButton>
        );
      },
    },
    {
      field: "campaignId",
      headerName: "Premium",
      width: 120,
      align: "center",
      headerAlign: "center",
      display: "flex",
      renderCell: (params) => {
        return (
          <input
            className="star"
            type="checkbox"
            name="presales"
            checked={!!params.value}
            readOnly
          />
        );
      },
    },
    {
      field: "enabled",
      headerName: "Visão dos Preços",
      type: "text",
      width: 100,
      align: "center",
      headerAlign: "center",
      description:
        "Pendente: cliente ainda não analisado, Aprovado: cliente aprovado para compras, Negado: cliente negado para compras",
      renderCell: (params) => {
        const handleIconClick = (e) => {
          e.stopPropagation(); // 👈 impede o clique de atingir o onRowClick
          handleOpen(e, params.row.cnpj_cpf, params.row.name);
        };

        switch (params.value) {
          case "Aprovado":
            return (
              <IconButton onClick={handleIconClick}>
                <CheckCircleOutlineOutlinedIcon color="success" />
              </IconButton>
            );
          case "Negado":
            return (
              <IconButton onClick={handleIconClick}>
                <RemoveCircleOutlineOutlinedIcon sx={{ color: "red" }} />
              </IconButton>
            );
          default:
            return (
              <IconButton onClick={handleIconClick}>
                <ReportGmailerrorredIcon sx={{ color: "#EE8253" }} />
              </IconButton>
            );
        }
      },
    },
    {
      field: "name",
      headerName: "Nome",
      width: 160,
      align: "left",
      headerAlign: "left",
      clickable: true,
      type: "text",
    },
    {
      field: "owner_cpf",
      headerName: "CPF",
      width: 120,
      align: "center",
      headerAlign: "center",
      type: "text",
    },
    {
      field: "cnpj_cpf",
      headerName: "CNPJ",
      width: 160,
      align: "center",
      headerAlign: "center",
      type: "text",
    },
    {
      field: "rzSocial",
      headerName: "Razão Social",
      width: 200,
      align: "left",
      headerAlign: "left",
      type: "text",
    },
    {
      field: "email",
      headerName: "Email",
      width: 200,
      align: "left",
      headerAlign: "left",
      type: "text",
    },
    {
      field: "contact",
      headerName: "Contato",
      width: 100,
      align: "center",
      headerAlign: "center",
      type: "text",
    },
    {
      field: "addressFormat",
      headerName: "End.",
      width: 120,
      align: "left",
      headerAlign: "center",
      type: "text",
    },
    {
      field: "managedBy",
      headerName: "Vendedor",
      width: 120,
      align: "center",
      headerAlign: "center",
      type: "text",
    },
    {
      field: "onlineStore",
      headerName: "Inta ou Loja virtual",
      width: 140,
      align: "center",
      headerAlign: "center",
      type: "text",
    },
    {
      field: "orderAmount",
      headerName: "Valor último pedido",
      width: 140,
      align: "center",
      headerAlign: "center",
      format: "BRL",
      type: "number",
    },
    {
      field: "days_order",
      headerName: "Dias último pedido",
      width: 140,
      align: "center",
      headerAlign: "center",
      type: "number",
    },
    {
      field: "cartTotal",
      headerName: "Valor carrinho",
      width: 120,
      align: "center",
      headerAlign: "center",
      format: "BRL",
      type: "number",
    },
    {
      field: "cartDate",
      headerName: "Data carrinho",
      width: 120,
      align: "center",
      headerAlign: "center",
      format: "dd/MM/yyyy",
      type: "date",
    },
    {
      field: "representante",
      headerName: "Representante",
      width: 120,
      align: "center",
      headerAlign: "center",
      type: "text",
    },
    {
      field: "createdAt",
      headerName: "Criado",
      width: 100,
      align: "center",
      headerAlign: "center",
      format: "dd/MM/yyyy",
      type: "date",
    },
    {
      field: "updatedAt",
      headerName: "Atualizado",
      width: 100,
      align: "center",
      headerAlign: "center",
      format: "dd/MM/yyyy",
      type: "date",
    },
    {
      field: "acessAt",
      headerName: "Último Acesso",
      width: 120,
      align: "center",
      headerAlign: "center",
      format: "dd/MM/yyyy",
      type: "date",
    },
    {
      field: "integrationId",
      headerName: "Integração",
      width: 90,
      align: "center",
      headerAlign: "center",
      type: "text",
    },
    {
      field: "hasUtm",
      headerName: "UTM",
      width: 70,
      align: "center",
      headerAlign: "center",
      display: "flex",
      renderCell: (params) =>
        params.value ? (
          <CampaignOutlinedIcon sx={{ color: "#EE8253" }} fontSize="small" />
        ) : null,
    },

    {
      field: "message",
      headerName: "",
      width: 80,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const { row } = params;

        if (row.managedBy !== null && row.address !== null) {
          const message = `
                Cliente ${row.name} já liberado para compras, segue:
                Nome: ${row.name}
                RzSocial: ${row.rzSocial || ""}
                CPF: ${row.owner_cpf || ""}
                CNPJ: ${row.cnpj_cpf || ""}
                Contato: ${row.contact || ""}
                Email: ${row.email || ""}
                End: ${row.address.street || ""}
                Complemento: ${row.address.complement || ""}
                Cidade: ${row.address.city || ""}
                UF: ${row.address.uf || ""}
                InstaLojaVirtual: ${row.onlineStore || ""}
                      `.trim();

          const encodedMessage = encodeURIComponent(message);
          const whatsappUrl = `https://wa.me/55${row.contactManagedBy}?text=${encodedMessage}`;

          const handleClick = (e) => {
            e.stopPropagation(); // impede que o clique dispare o onRowClick
            window.open(whatsappUrl, "_blank"); // abre em nova aba
          };

          return (
            <IconButton onClick={handleClick}>
              <MessageIcon />
            </IconButton>
          );
        }

        return null;
      },
    },
    // {
    //   field: "deletar",
    //   headerName: "",
    //   width: 80,
    //   align: "center",
    //   headerAlign: "center",
    //   renderCell: (params) => {
    //     const handleDeleteClick = (e) => {
    //       e.stopPropagation(); // impede o clique de acionar o onRowClick
    //       onButtonDeleteClick(e, params.row.customerId);
    //     };

    //     return (
    //       <IconButton onClick={handleDeleteClick}>
    //         <DeleteOutline />
    //       </IconButton>
    //     );
    //   },
    // },
  ];

  return (
    <div className="cust-page">
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div style={style}>
          <>
            <table className="table">
              <tbody>
                <tr>
                  <td align="left" width="100%">
                    <tr>
                      <td>
                        <img src={cadastro} />
                      </td>
                      <td>
                        <tr className="labelTitle">{name}</tr>
                      </td>
                    </tr>
                  </td>
                  <td align="left" width="0%">
                    {" "}
                  </td>
                </tr>
              </tbody>
            </table>
            <table
              cellSpacing="1"
              cellPadding="2"
              align="center"
              className="table"
            >
              <tbody>
                <tr>
                  <td align="left" className="left">
                    Razão Social:
                  </td>
                  <td align="left" className="right_black_List">
                    {modalCustomer ? modalCustomer.razao_social : ""}
                  </td>
                </tr>
                <tr>
                  <td align="left" className="left">
                    Socio:
                  </td>
                  <td align="left" className="right_black_List">
                    {modalCustomer ? modalCustomer.socio : ""}
                  </td>
                </tr>
                <tr>
                  <td align="left" className="left">
                    Capital Social:
                  </td>
                  <td align="left" className="right_black_List">
                    {modalCustomer
                      ? formatPricing(modalCustomer.capital_social)
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td align="left" className="left">
                    Porte:
                  </td>
                  <td align="left" className="right_black_List">
                    {modalCustomer ? modalCustomer.porte : ""}
                  </td>
                </tr>
                <tr>
                  <td align="left" className="left">
                    Natureza Júridica:
                  </td>
                  <td align="left" className="right_black_List">
                    {modalCustomer ? modalCustomer.natureza_juridica : ""}
                  </td>
                </tr>
                <tr>
                  <td align="left" className="left">
                    Qualificação Responsável:
                  </td>
                  <td align="left" className="right_black_List">
                    {modalCustomer
                      ? modalCustomer.qualificacao_do_responsavel
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td align="left" className="left">
                    Endereço:
                  </td>
                  <td align="left" className="right_black_List">
                    {modalCustomer && modalCustomer.end_empresa
                      ? modalCustomer.end_empresa +
                        "," +
                        modalCustomer.end_num_empresa
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td align="left" className="left">
                    Complemento:
                  </td>
                  <td align="left" className="right_black_List">
                    {modalCustomer ? modalCustomer.end_comp_empresa : ""}
                  </td>
                </tr>
                <tr>
                  <td align="left" className="left">
                    Bairro:
                  </td>
                  <td align="left" className="right_black_List">
                    {modalCustomer ? modalCustomer.end_bairro : ""}
                  </td>
                </tr>
                <tr>
                  <td align="left" className="left">
                    CEP:
                  </td>
                  <td align="left" className="right_black_List">
                    {modalCustomer ? modalCustomer.end_cep : ""}
                  </td>
                </tr>
                <tr>
                  <td align="left" className="left">
                    Telefone:
                  </td>
                  <td align="left" className="right_black_List">
                    {modalCustomer && modalCustomer.end_ddd
                      ? "(" + modalCustomer.end_ddd + ")"
                      : ""}
                    {modalCustomer ? modalCustomer.end_tel : ""}
                  </td>
                </tr>
                <tr>
                  <td align="left" className="left">
                    Estado:
                  </td>
                  <td align="left" className="right_black_List">
                    {modalCustomer ? modalCustomer.end_estado : ""}
                  </td>
                </tr>
                <tr>
                  <td align="left" className="left">
                    Cidade:
                  </td>
                  <td align="left" className="right_black_List">
                    {modalCustomer ? modalCustomer.end_cidade : ""}
                  </td>
                </tr>
                <tr>
                  <td align="left" className="left">
                    Atividade Principal:
                  </td>
                  <td align="left" className="right_black_List">
                    {modalCustomer ? modalCustomer.atividadePrincipal : ""}
                  </td>
                </tr>
                <tr>
                  <td align="left" className="left">
                    Inscrição Estadual:
                  </td>
                  <td align="left" className="right_black_List">
                    {modalCustomer ? modalCustomer.inscricao_estadual : ""}
                  </td>
                </tr>
                <tr>
                  <td align="left" className="left">
                    Data inicio atividade:
                  </td>
                  <td align="left" className="right_black_List">
                    {modalCustomer
                      ? formatTimeDDMMYYY(modalCustomer.data_inicio_atividade)
                      : ""}
                  </td>
                </tr>
              </tbody>
            </table>
          </>
        </div>
      </Modal>

      {from && (
        <div
          onClick={() => nav(`/${slug}/${from}`)}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            marginBottom: 12,
            cursor: "pointer",
            color: "#6B7280",
            fontSize: 13,
            fontWeight: 600,
            fontFamily: "Manrope",
            padding: "6px 12px",
            borderRadius: 8,
            border: "1px solid #E5E7EB",
            background: "#fff",
            boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
          }}
        >
          ← Voltar para Indicadores
        </div>
      )}

      {isLoading ? (
        <Loading />
      ) : (
        <>
          <CustomGrid
            toolbarActions={
              <Button
                variant="contained"
                color="secondary"
                startIcon={<AddIcon />}
                onClick={addRow}
                size="small"
              >
                Adicionar Cliente
              </Button>
            }
            gridId="customerList"
            rows={data}
            columns={columns}
            checkboxSelection={false}
            defaultFilterText="Pendente"
            defaultFilterColumn="enabled"
            //onRowClick={(row) => nav(`${row.customerId}`)}
            pageSize={pageSize}
            serverSide={true}
            rowCount={totalRows}
            onPageChangeServer={handlePageChangeServer}
            callExport="get"
            endpopintExport="/customers"
            tableHeight="calc(100vh - 110px)"
          />
        </>
      )}
    </div>
  );
}
